import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogRef, DynamicDialogConfig } from "primeng/dynamicdialog";
import { DataService_ScheduledJobs } from "../../shared/data.service";
import { JobUpdateRequest } from "../../shared/job-update-request";
import { StringRequest } from "../../shared/string-request";

@Component({
	selector: "app-ri-job-edit",
	templateUrl: "./ri-job-edit.component.html",
	styleUrls: ["./ri-job-edit.component.css"],
})
export class RiJobEditComponent implements OnInit {
	constructor(
		private ref: DynamicDialogRef,
		private dialogConfig: DynamicDialogConfig,
		private confirmationService: ConfirmationService,
		private dataService: DataService_ScheduledJobs
	) {}

	ngOnInit(): void {
		this.JobID = this.dialogConfig.data.JobID;
		this.JobDesc = this.dialogConfig.data.JobDesc;
		this.Active = this.dialogConfig.data.Active;

		this.loadReportScripts();
	}

	/////////////////////////////////////////////////////////
	// Data
	/////////////////////////////////////////////////////////

	JobID: number = -1;
	JobDesc: string = "";

	SelectedReportScript: any;
	lstReportScript: any = [];
	LoadingReportScript: boolean = false;
	LoadingParameters: boolean = false;

	Active: boolean = false;

	Processing: boolean = false;
	errorMessage: string = "";

	/////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////
	// Load Data
	/////////////////////////////////////////////////////////

	loadReportScripts() {
		this.LoadingReportScript = true;

		var result = this.dataService.ReportScriptsSelectList();
		result.subscribe(
			(response) => {
				this.lstReportScript = response;

				this.SelectedReportScript = this.lstReportScript[0];

				for (var z = 0; z < this.lstReportScript.length; z++) {
					var next = this.lstReportScript[z];

					if (next.ReportScriptID == this.dialogConfig.data.ReportScriptID) {
						this.SelectedReportScript = next;
						break;
					}
				}

				var lstParms = this.dialogConfig.data.lstParameters;
				if (lstParms != undefined && lstParms.length > 0) {
					for (var i = 0; i < lstParms.length; i++) {
						var nextVal = lstParms[i];
						for (var j = 0; j < this.SelectedReportScript.lstParameters.length; j++) {
							var nextListItem = this.SelectedReportScript.lstParameters[j];

							if (nextVal.ParameterDesc == nextListItem.ParameterDesc) {
								nextListItem.ParameterValue = nextVal.ParameterValue;
								break;
							}
						}
					}
				}

				this.loadParameters(true);

				this.LoadingReportScript = false;
			},
			(error) => {
				this.LoadingReportScript = false;
			}
		);
	}

	/////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////
	// Buttons
	/////////////////////////////////////////////////////////

	onUpdate() {
		this.errorMessage = "";

		if (this.JobDesc == "") {
			this.errorMessage = "Enter name/description of the job";
			return;
		}

		if (this.SelectedReportScript.ReportScriptID <= 0) {
			this.errorMessage = "Select which report to generate";
			return;
		}

		var lstParmIDs: number[] = [];
		var lstParmValues: string[] = [];

		if (this.SelectedReportScript.lstParameters != undefined && this.SelectedReportScript.lstParameters.length > 0) {
			lstParmIDs = this.SelectedReportScript.lstParameters.map((item) => item.ParameterID);
			lstParmValues = this.SelectedReportScript.lstParameters.map((item) => item.ParameterValue);
		}

		var parms: JobUpdateRequest = {
			JobID: this.JobID,
			JobDesc: this.JobDesc,
			ReportScriptID: this.SelectedReportScript.ReportScriptID,
			Active: this.Active,
			lstParameterID: lstParmIDs,
			lstParameterValue: lstParmValues,
		};

		this.Processing = true;

		var result = this.dataService.JobUpdate(parms);
		result.subscribe(
			(response: any) => {
				this.Processing = false;

				if (response.Success == true) {
					this.confirmationService.confirm({
						key: "editjob",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Job was updated successfully. When the job runs you will be able to see the results from your inbox.",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					this.confirmationService.confirm({
						key: "editjob",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could not update the job: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onClose() {
		this.ref.close(0);
	}

	/////////////////////////////////////////////////////////

	loadParameters(init: boolean = false) {
		this.LoadingParameters = true;

		for (var z = 0; z < this.SelectedReportScript.lstParameters.length; z++) {
			var next = this.SelectedReportScript.lstParameters[z];

			if (next.ParameterOptions != undefined && next.ParameterOptions != "") {
				next.UseList = true;
				next.lstOptions = [];

				if (next.ParameterOptions.indexOf("|") > 0) {
					next.lstOptions = [];

					var lstTemp = next.ParameterOptions.split("|");

					for (var x = 0; x < lstTemp.length; x++) {
						var nextTemp = lstTemp[x];
						var nextOption = {
							ID: nextTemp,
							Desc: nextTemp,
						};

						next.lstOptions = [...next.lstOptions, nextOption];
					}

					if (init == true) {
						for (var x = 0; z < next.lstOptions.length; x++) {
							var nextOpt = next.lstOptions[x];
							if (nextOpt.ID == next.ParameterValue) {
								next.ParameterValue = nextOpt.ID;
							}
						}
					} else {
						next.ParameterValue = next.lstOptions[0].ID;
					}
				} else {
					this.ReportScriptOptionSelectList(next, init);
				}
			} else {
				next.UseList = false;
			}
		}

		this.LoadingParameters = false;
	}

	ReportScriptOptionSelectList(parameter: any, init: boolean) {
		var parms: StringRequest = {
			str: parameter.ParameterOptions,
		};

		var result = this.dataService.ReportScriptOptionSelectList(parms);
		result.subscribe(
			(response: any) => {
				parameter.lstOptions = response;

				if (init == true) {
					for (var z = 0; z < parameter.lstOptions.length; z++) {
						var next = parameter.lstOptions[z];
						if (next.ID == parameter.ParameterValue) {
							parameter.ParameterValue = next.ID;
						}
					}
				} else {
					parameter.ParameterValue = parameter.lstOptions[0].ID;
				}
			},
			(error) => {}
		);
	}

	/////////////////////////////////////////////////////////
	// Helpers
	/////////////////////////////////////////////////////////

	IsLoading() {
		return this.LoadingReportScript == true || this.LoadingParameters == true || this.Processing == true;
	}

	/////////////////////////////////////////////////////////
}
